import Backbone from 'backbone'
import $ from 'jquery'
import appDisplay from 'scoreboard/components/app-display'
import _ from 'lodash'
import conductor from 'scoreboard/components/conductor'
import Finder from 'scoreboard/components/finder'
import moment from 'moment'
import formatValue from 'scoreboard/components/format-value'
import tabs from '../initiatives-tabs.hbs'
import template from './initiatives-timeline.hbs'
import InitiativesDisplayHeader from '../initiatives-display-header'
import Initiative from '../initiative'
import Gantt from 'scoreboard-gantt'
import layoutManager from 'scoreboard/components/layout-manager'
import Tooltip from 'scoreboard/components/tooltip'
import toolTipTemplate from './initiative-timeline-tooltip.hbs'
import OverviewInfo from '../overview/initiatives-overview-info'
import HistoricalTable from '../overview/historical-table'
import statusTemplate from './status-dialog.hbs'
import context from '../overview/initiatives-context'
import guard from 'scoreboard/components/unsaved/guard'
import SendToOptions from 'scoreboard/components/send-to-options'
import escapePreserveLineBreaks from 'scoreboard/components/escape-preserve-line-breaks'
import permissions from 'scoreboard/components/permissions'
import expandCollapseButton from 'scoreboard/components/bottom-toolbar-expand-collapse-button.hbs'
import ScheduleWarning from '../schedule-warning'
import siprNodeTransform from 'scoreboard/components/sipr-node-transform'
import i18n from 'scoreboard/components/i18n'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import mobile from 'scoreboard/components/mobile'
import momentHelper from 'scoreboard/components/moment-helper'
import arrayToHash from 'scoreboard/components/array-to-hash'
import nodeWidth from 'scoreboard/components/node-width'
import constants from 'scoreboard/components/constants'
import deviceType from 'scoreboard/components/device-type'
import ImportOptions from 'scoreboard/components/import-options'
import DataType from 'scoreboard/datasets/model/data-type'
const { PERCENT, DATE } = DataType
import isBehindSchedule from '../is-behind-schedule'
import { getScheduleStatusIconAndColor, getBudgetStatusIconAndColor } from '../status-icon-and-color'
import { BEHIND_RED } from '../schedule-status'

/*
 * Transforms a task into an object with state needed by the gantt chart.
 */
const taskTransform = task => {
	task.startDate = task.aggregatedStartDate ? moment(task.aggregatedStartDate).toDate() : null
	task.endDate = task.aggregatedEndDate ? moment(task.aggregatedEndDate).toDate() : null

	if (task.aggregatedCompletionDate) {
		// It's complete
		task.state = 'gantt-item-complete'
	} else if (task.percentComplete > 0 && task.type !== 'milestone') {
		// Started, but not complete
		task.state = 'gantt-item-in-progress'
	} else {
		task.state = 'gantt-item-uncomplete'
	}

	let taskModel = new Initiative(task)

	let pastDueDateStatus = taskModel.getPastDueDateStatus()
	if (pastDueDateStatus) {
		// Projects are on or ahead of schedule, but we're past the due date,
		// so force it to be yellow/red
		task.scheduleStatus = pastDueDateStatus
	}

	/* Mark unknown status, which could be:
	 *   1. Unstarted but "okay". e.g. a milestone that isn't completed and its due date is in the future.
	 *			Or for tasks/initiatives, it hasn't been started and there's a start date in the future.
	 *			This is also a state used when an item doesn't have a percet complete and its children do (can't roll up percent complete from children)
	 *   2. Unstarted but "bad". e.g. a milestone that isn't complete and its due date is in the past.
	 *			Or for tasks/initiatives, it's items that haven't been started and a start date is in the past.
	 *
	 * If it's in this state, mark a `duration`
	 */
	if (task.percentComplete) {
		// set the status label based on the percent complete
		task.statusLabel = formatValue({value: task.percentComplete, dataType: PERCENT})
	} else if (task.endDate && task.startDate) {
		// Set the status label as the duration of the task/initiative
		task.statusLabel = moment(task.endDate).from(moment(task.startDate), true)
	}

	return task
}


var HistoricalPerformance = Backbone.View.extend({

	className: 'initiatives-historical initiatives-timeline',

	events: {
		'click .done': 'done'
	},

	initialize: function (opts) {
		this.gantt = opts.gantt
	},

	render: function () {
		this.$el.empty().html(statusTemplate())
		this.historicalTable = new HistoricalTable({model: this.model, treeCalculations: true}).render()
		this.$('.dialog-body-content .panel-content').append(this.historicalTable.el)
		this.historicalTable.render()
		this.model.on('save:status', () => {
			this.render()
		})

		// When there is a status update, the tree calculations may have changed, so we must
		// redraw the nodes
		this.model.on('save:status remove:status', (status, oldStatuses, data) => {
			this.gantt.tree.edit(data.treeCalculations.map(taskTransform).map(siprNodeTransform))
		})
		this.historicalTable.addStatus()
	},

	done: function () {
		guard.conditionallyRun(() => this.trigger('cancel'))
	}

})

var TimelineTooltip = Backbone.View.extend({

	events: {
		'click .info': 'info',
		'click .add-status': 'addStatus'
	},

	initialize: function (opts) {
		this.gantt = opts.gantt
	},

	addStatus: function () {
		appDisplay.dialog(new HistoricalPerformance({ model: this.model, gantt: this.gantt }))
	},

	info: function () {
		appDisplay.dialog(this.model.fetch({
			data: {
				relatedItems: true,
				assignees: true
			}
		}), () => new OverviewInfo({ model: this.model }))
	},

	render: function () {
		let budgetCompletionSuffix = this.model.get('aggregatedCompletionDate') ? '.completed' : ''
		let scheduleCompletionSuffix = !!this.model.get('aggregatedCompletionDate') ? '.completed' : ''
		let ctx = context(this.model)

		let scheduleStatus = _.result(this.model.get('projectedSchedule'), 'status')
		let projectedScheduleDescription = scheduleStatus === 'no-data'
			? i18n.get('initiatives.projectedSchedule.noData')
			: ctx.value('initiatives.projectedSchedule')

		let budgetStatus = _.result(this.model.get('projectedBudget'), 'status')
		let projectedBudgetDescription = budgetStatus === 'no-data'
			? i18n.get('initiatives.projectedBudget.noData')
			: i18n.get(_.result(this.model.get('projectedBudget'), 'descriptiveMessageCode'), ctx.value('initiatives.projected.Pct'))

		this.$el.html(toolTipTemplate(_.extend(this.model.toJSON(), {
			description: escapePreserveLineBreaks(this.model.get('description')),
			ownStatuses: this.model.statusType() === 'own',
			editableStatus: permissions.updateInitiativeStatus(this.model.get('organizationId')) && permissions.isEditableIfReplicated(this.model),
			scheduleHeaderLabel: 'initiatives.projectedSchedule' + scheduleCompletionSuffix,
			budgetHeaderLabel: 'initiatives.projectedBudget' + budgetCompletionSuffix,
			projectedSchedule: projectedScheduleDescription,
			projectedBudget: projectedBudgetDescription,
			editable: this.model.isEditable(),
			hasBudget: !!ctx.value('initiatives.budget')
		})))

		this.scheduleWarning = new ScheduleWarning({ model: this.model })
		this.$('.schedule-warning-container').append(this.scheduleWarning.el)
		this.scheduleWarning.render()

		this.$('.schedule-warning-container').toggleClass('is-not-displayed', !this.scheduleWarning.showing())

		let scheduleColor = getScheduleStatusIconAndColor(this.model).statusColor
		this.$('.projected-schedule').addClass(`status-color-${scheduleColor}`)

		let budgetColor = getBudgetStatusIconAndColor(this.model).statusColor
		this.$('.projected-total-budget').addClass(`status-color-${budgetColor}`)

		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })

		return this
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.scheduleWarning, this.covertButtonTooltips], 'remove')
	}

})

var InitiativesTimeline = Backbone.View.extend({

	className: 'display-layout table-hack initiatives-timeline',

	deferredReady: true,

	/**
	 * @param {Boolean} [options.initialExpansion='collapseAll'] initial expansion state
	 * of the tree. Can be 'collapseAll', 'expandOneLevel', or 'expandAll'
	 *
	 * @param {Object} [options.state.extent] - startDate and endDate for the
	 * displayed area of the timeline (the "extent" in gantt options)
	 *
	 * @param {Int[]} [options.state.expandedIds] - array of initiative IDs that
	 * should initially be expanded
	 *
	 * @param {Int} [options.state.leftPaneWidth] - initial width of the left pane
	 */
	initialize: function (options) {
		this.options = options || {}

		_.defaults(this.options, { initialExpansion: 'collapseAll' })

		// The current initiative
		let initiative = options.data.find(d => d.id == options.initiativeId)
		this.model = new Initiative(initiative)

		this.listenTo(this, 'resize', this.resize)
	},

	render: function () {
		this.$el.append(this.header().el, template())

		let buildGraphView = () => {
			let container = this.$('.grid')[0]
			this.graphView = new GraphView(_.extend(_.cloneDeep(this.options), {
				el: container,
				model: this.model,
				initialSelection: this.options.initiativeId,
				state: this.options.state,
				width: container.offsetWidth,
				// This is the view for Initiatives > Timeline; the user won't ever get here unless
				// they can view the org
				canViewOrg: true
			})).render()

			this.graphView.on('ready', () => this.trigger('ready'))
			this.secure()

			// Setup gantt-pane-left expanding/contracting when an overflowing
			// node name is hovered over.
			this.graphView.gantt.tree.on('rendered', () => {
				this.$('.tree').addClass('tree-hover-expand-contract')

				var mouseEnter = e => {
					var target = this.$(e.currentTarget)
					var expandTimer

					if (this.isResizingTree) {
						return
					}

					var expand = () => {
						expandTimer = setTimeout(() => {
							let node = target.closest('.node')
							let width = nodeWidth(node)
							let containerWidth = node.find('.gantt-pane-left').outerWidth()
							// If the node width is wider than the container (minus the mask width
							// compensating for the fade-out effect), expand the tree.
							if (width > containerWidth - constants.TREE_NODE_MASK_WIDTH) {
								this.originalWidth = containerWidth
								this.isResizingTree = true
								this.graphView.setTreeWidth(width + constants.TREE_NODE_MASK_WIDTH)
							}
						}, constants.TREE_EXPAND_DELAY)
					}

					expand()

					target.on('mousemove', () => {
						clearTimeout(expandTimer)
						expand()
					})

					// When we exit the currently expanded node, contract the tree.
					target.on('mouseleave click', () => {
						clearTimeout(expandTimer)

						if (!this.isResizingTree) {
							return
						}

						this.graphView.setTreeWidth(this.originalWidth)
						target.one('transitionend', () => this.isResizingTree = false)
					})
				}

				this.$('.node .gantt-pane-left').on('mouseenter', mouseEnter)

				// When something has happened with the tree's DOM structure, re-listen
				// for the mouseenter event to make sure even new nodes are covered.
				this.graphView.gantt.tree.on('rebind', () => {
					// We need to wait for new nodes to enter the DOM
					process.nextTick(() => {
						this.$('.node .gantt-pane-left')
							.off('mouseenter')
							.on('mouseenter', mouseEnter)
					})
				})
			})
		}

		// If we're showing the timeline within the timeline section, the nav
		// pane should first be collapsed. If we render the graph view before that's done, we'll
		// end up with inacurate width calculations during the render process (#23764).
		if (_.isNil(this.options.external) && !mobile.isMobileOrientation()) {
			layoutManager.toggleNavCollapsible(false) // #28338
			layoutManager.toggleNavCollapsed(true).then(() => buildGraphView())
		} else {
		// We're outside the timelne section and there's no nav collapsing. Go ahead
		// and build that graph view.
			buildGraphView()
		}
	},

	/*
	 * Clicking within the gantt chart allows the user to change the current initiative.
	 * When that happens, we need to adjust the header so the links work w/ the selected
	 * initiative.
	 */
	header: function () {
		this.header = new InitiativesDisplayHeader({
			model: this.model,
			sendToOptions: SendToOptions.default({
				section: 'initiatives',
				uiState: this.getState.bind(this)
			}),
			importOptions: ImportOptions.forInitiativeItem(this.model),
			subsection: 'timeline',
			tabs: tabs({
				id: this.model.id,
				section: 'initiatives'
			})
		}).render()
		return this.header
	},

	resize: function () {
		this.graphView && this.graphView.resize({width: this.$('.grid')[0].offsetWidth })
	},

	secure: function() {
		this.header.conditionallyHideEditTab(this.model.isEditable())
	},

	getState: function(opt = {}) {
		return _.invoke(this.graphView, 'getState', opt)
	},

	remove: function () {
		this.graphView && this.graphView.remove()
		Backbone.View.prototype.remove.apply(this, arguments)
	}
})

var GraphView = Backbone.View.extend({

	events: {
		'click .expand-collapse': 'toggleExpandAll'
	},

	/**
	 * @param {Object} options.state state read from persisted-view-state.js
	 *
	 * @param {Integer} options.initialSelection ID of the item to initially be selected
	 */
	initialize: function (options) {
		this.options = options || {}
		this.isCollapsed = true // Never starts out fully expanded

		if (!this.model) {
			// The current initiative
			let initiative = options.data.find(d => d.id == options.initiativeId)
			this.model = new Initiative(initiative)
		}

		const ids = _.get(options.state, 'expandedIds')
		const hasExpandedIds = !_.isUndefined(ids)
		const expandedIds =  hasExpandedIds ? arrayToHash(ids) : []

		this.options.data = options.data
			.map(taskTransform)
			.map(siprNodeTransform)
			.map(node => {
				// Make sure the timeline doesn't show archived nodes #17735
				node.visible = _.isNil(node.archiveDate)
				if (hasExpandedIds) {
					node.collapsed = !expandedIds[node.id]
				} else {
					if (this.options.initialExpansion === 'collapseAll') {
						node.collapsed = true
					} else if (this.options.initialExpansion === 'expandOneLevel') {
						node.collapsed = !!node.parentId
					} else if (this.options.initialExpansion === 'expandAll') {
						node.collapsed = false
					}
				}
				return node
			})

		const persistedExtentState = _.get(options.state, 'extent')
		if (persistedExtentState) {
			this.options.extent = [
				moment(persistedExtentState.startDate),
				moment(persistedExtentState.endDate)
			]
		}

		const persistedLeftPaneWidth = _.get(options.state, 'leftPaneWidth')
		if (!_.isNil(persistedLeftPaneWidth)) {
			this.options.leftPaneWidth = persistedLeftPaneWidth
		}

		this.finder = new Finder()
		this.finder.on('find', this.find.bind(this))
	},

	toggleExpandAll: function (e) {
		// don't let clicking on expand all in org pane make org pane hide since
		// expand all button for nav pane is beneath it
		e && e.stopPropagation()

		this.finder.clear()
		this.gantt.tree.search(null)

		this.isCollapsed ? this.gantt.tree.expandAll() : this.gantt.tree.collapseAll()
		this.isCollapsed = !this.isCollapsed
		this.$('.icon-collapse-all, .nav-collapse-text').toggleClass('is-not-displayed', this.isCollapsed)
		this.$('.icon-expand-all, .nav-expand-text').toggleClass('is-not-displayed', !this.isCollapsed)
	},

	find: function (text) {
		this.gantt.tree.search(text)
	},

	resize: function (dim) {
		this.gantt.setWidth(dim.width)
		this.gantt.render()
		// we want the tree (.tree-container-light) to show score colors when nodes are selected
		this.gantt.tree.el.classed('show-score-colors', true)
		if (!this.options.external) {
			// Make sure the nav pane stays collapsed while the browser is resized #17725
			layoutManager.toggleNavCollapsed(true)
		}
	},

	/*
	 * Updates the model w/ the node the user just clicked
	 */
	updateModel: function (id) {
		// Update the model
		let initiative = this.options.data.find(init => init.id == id)
		this.model.clear({silent: true})
		this.model.set(initiative)
	},

	render: function() {
		const expandCollapse = layoutManager.export ? '' : expandCollapseButton()
		let footerHtml = `<div class="nav-or-tree-toolbar nav-bottom-toolbar">${expandCollapse}</div>`
		this.gantt = new Gantt(this.el, this.options.data, {
			initialSelection: this.options.initialSelection,
			treeHeader: this.finder.render().el,
			treeFooter: $(footerHtml)[0],
			formatter: function (value) {
				// Used for format the x-axis dates
				return formatValue({
					value: value,
					dataType: DATE
				})
			},
			leftPane: this.options.showLeftPane,
			showFooter: this.options.showFooter,
			extent: this.options.extent,
			leftPaneWidth: this.options.leftPaneWidth,
			width: this.options.width
		})

		if (layoutManager.export) { // #26508 - Don't auto-expand selected node
			this.gantt.tree.options.toggleOnSelect = false
		}

		// #17860 the user may see a timeline even if they can't normally view the org
		// (like when viewed in a dashboard), but they shouldn't be able to click on
		// the chart and get the detailed tooltip
		if (this.options.canViewOrg) {
			/*
			 * Click events for clicking on an actual gantt shape drawing
			 */
			this.gantt.on('click', (e, node, id) => {
				if (layoutManager.sharedResource) {
					conductor.navigate(`initiatives/${id}/timeline`)
				} else {
					this._onGanttClick(e, id, node)
				}
			})

			this.$el.addClass('is-org-viewable')
		}

		/*
		 * Tree events for selecting a node.
		 * This happens anytime a node is clicked. This is the entire tree node
		 * so the entire row: left pane + right pane
		 */
		this.gantt.tree.on('select', node => {
			// The path to which we are to update the url each time someone clicks on a node
			var path = `initiatives/${node.id}/timeline`

			this.updateModel(node.id)

			if (!this.options.external) {
				// Change the url as long as this isn't an external timeline inside of a wob.
				conductor.navigate(path)
			}
		})

		const tree = this.gantt.tree

		if (layoutManager.export) {
			this.gantt.render()
			$(this.finder.el).hide()

			tree.on('rendered', () => {
				// Export uses nodes that aren't absolute positioned, so we can cleanly break between pages
				// Sort the tree so the nodes are in the correct DOM order
				tree.el.selectAll('li.node')
					.sort((a, b) => a._y - b._y)

				this.trigger('ready')
			})
		} else if (!this.options.external) {
			// If this timeline isn't showing up externally (outside the initiatives section)
			// close the .nav-pane and make it non-collapsible
			layoutManager.toggleNavCollapsible(false)
			layoutManager.toggleNavCollapsed(true)
						 .then(() => {
							this.resize({width: this.options.width})
						 })
		} else {
			this.resize({width: this.options.width})
		}

		// If there's a search term to populate, wait till the gantt tree is
		// ready and then conduct the search
		if (this.options.searchTerm) {
			this.gantt.tree.options.stream.on('end', () => {
				// Without waiting for the next tick here, the search is blown
				// away as the gantt tree finishes expanding for the first time.
				process.nextTick(() => {
					this.finder.text(this.options.searchTerm)
				})
			})
		}

		return this
	},

	_onGanttClick: function (e, id, node) {
		// Issue #16970 - Never toggle the tree's children when clicking on the shape
		e.stopPropagation() // So the tree doesn't toggle
		if (this.tooltip) {
			let initiativeId = this.tooltip.options.initiativeId
			// Since we're invoking `stopPropagation` a previous tooltip won't
			// know to remove itself, so let's make sure that's cleaned.
			this.tooltip.remove()
			this.tooltip = null

			if (initiativeId === id) {
				// 2nd click on an initiative item should just hide the tooltip
				// without showing it again. See #18124
				return
			}
		}
		let x = e.clientX // We want to position the tooltip where the
								 // user clicked. See #16506
		let target = e.target // Store in case they clicked a milestone

		this.updateModel(id) // Sets the correct id on our model
		this.model.fetch({data: {notes: true}}).then(() => {
			// We have an updated model w/ data needed by the tooltip, such as
			// the projections and status updates, so
			let opts = {
				content: new TimelineTooltip({
					model: this.model,
					gantt: this.gantt
				}),
				attachTo: node,
				placement: 'above',
				initiativeId: id,
				arrow: 'center',
				extraClass: 'initiatives-timeline-tooltip'
			}

			if (this.model.get('type') === 'milestone') {
				opts.attachTo = target // Always center the tooltip on the
									   // milestone rect  #18169
			} else {
				// Attach the tooltip arrow to the mouse click location for
				// non-milestones.
				opts.attachToPoint = {x}
			}

			// now show the tooltip
			this.tooltip = new Tooltip(opts).render()
		})
	},

	layout({ showLeftPane, showFooter, extent, expandAll, initialExpansion }) {
		if (this.gantt) {
			// #32538 If dimensions.left.width == 0, the left pane wasn't showing.
			// Only call toggleLeftPane() if it's changing, or it will reset to
			// the default width
			let oldShowLeftPane = !!this.gantt.dimensions.left.width
			if (oldShowLeftPane != showLeftPane) {
				this.gantt.toggleLeftPane(showLeftPane)
			}

			this.gantt.toggleFooter(showFooter)
			this.gantt.setExtent(extent)

			if (initialExpansion === 'expandAll') {
				this.gantt.tree.expandAll()
			} else if (initialExpansion === 'collapseAll') {
				this.gantt.tree.collapseAll()
			} else if (initialExpansion === 'expandOneLevel') {
				let rootIds = this.options.data.filter(item => !item.parentId).map(item => item.id)
				let expandedNodes = this.gantt.tree.expandedNodes()
				let expandedNodeIds = expandedNodes.map(node => node.id)

				// First find all direct children of the roots that are expanded,
				// and collapse them. We only need to collapse those because any
				// lower descendants are not visible anyway
				expandedNodes
					.filter(node => _.includes(rootIds, node.parentId))
					.forEach(node => this.gantt.tree.collapse(node))

				// Now find all root nodes that are collapsed and expand them
				rootIds
					.filter(rootId => !_.includes(expandedNodeIds, rootId))
					.forEach(rootId => this.gantt.tree.expand(rootId))
			}
		}
	},

	/**
	 * @param opt.export Is this for an export
	 * @param opt.scheduled Is this for a scheduled export
	 */
	getState: function (opt = {}) {
		let state = {}

		if (opt.export && !opt.scheduled) { // assigned in send-to-export.js
			// Only included the date range window's state if doing an "instant"
			// export; we want to use the configured date range for bookmarks,
			// briefings, and scheduled exports.
			// https://github.com/SpiderStrategies/Scoreboard/issues/24709#issuecomment-499219450
			let extent = _.result(this, 'gantt.extent')
			if (!_.isEmpty(extent)) {
				state.extent = {
					startDate: momentHelper.isoDate(moment(extent[0])),
					endDate: momentHelper.isoDate(moment(extent[1]))
				}
			}
		}

		let expandedNodes = _.result(this, 'gantt.tree.expandedNodes')
		if (!_.isEmpty(expandedNodes)) {
			state.expandedIds = expandedNodes.map(n => n.id)
		}

		let leftPaneWidth = _.result(this, 'gantt.dimensions.left.width')
		if (!_.isNil(leftPaneWidth)) {
			state.leftPaneWidth = leftPaneWidth
		}

		return state
	},

	setTreeWidth(width) {
		if (deviceType.touchOnly) {
			return
		}

		let ganttContainer = $(this.gantt.container)
		let adjustedWidth = Math.min(width, ganttContainer.width() - 50)
		ganttContainer.find('.gantt-pane-left').css('width', `${adjustedWidth}px`)
		ganttContainer.find('.gantt-pane-right').css('margin-left', adjustedWidth + 'px')
		ganttContainer.find('.gantt-pane-resizer').css('left', adjustedWidth + 'px')
	},

	remove: function () {
		_.invokeMap([this.tooltip, this.finder], 'remove')
		Backbone.View.prototype.remove.apply(this, arguments)
	}

})

InitiativesTimeline.GraphView = GraphView

export default InitiativesTimeline
InitiativesTimeline.__filename__ = 'initiatives/timeline/initiatives-timeline.js'
